<template>
  <ag-grid-vue
    class="ag-theme-alpine table-style"
    :gridOptions="gridOptions"
    @grid-ready="onGridReady"
    :columnDefs="columnDefs"
    :rowData="rowData"
    suppressDragLeaveHidesColumns
    suppressMovableColumns
    :checkboxSelection="false"
    @first-data-rendered="onDataRendered"
  >
  </ag-grid-vue>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import baseUrl from "../../../util/backend";

import { toShowAccountingPrice } from "../../../util/accountingPrice";
export default {
  props: {
    jvData: {
      type: Array,
      default: () => [],
    },
    jvTotal: {
      type: Object,
    },
  },
  components: {
    AgGridVue,
  },
  data() {
    return {
      gridApi: null,
      gridColumnApi: null,
      gridOptions: {
        rowHeight: 50,
        defaultColDef: {
          resizable: true,
        },
        getRowStyle: (params) => {
          if (params.node.footer) {
            return { background: "red" };
          }
        },
      },
      columnDefs: [
        {
          headerName: this.$t("asset.acc_code"),
          field: "acc_code",
          sortable: true,
          width: 200,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("asset.acc_name"),
          field: "acc_name",
          sortable: true,
          width: 200,
        },
        {
          headerName: "Debit",
          field: "debit",
          sortable: true,
          suppressSizeToFit: true,
          cellClass: "text-end",
          cellRenderer: (params) => {
            return params.value || "-";
          },
        },
        {
          headerName: "Credit",
          field: "credit",
          sortable: true,
          suppressSizeToFit: true,
          cellClass: "text-end",
          cellRenderer: (params) => {
            return params.value || "-";
          },
        },
      ],
    };
  },
  computed: {
    rowData() {
      return this.jvData.map((acc) => {
        return {
          acc_code: acc.key,
          acc_name: acc.name,
          debit: toShowAccountingPrice(acc.debit),
          credit: toShowAccountingPrice(acc.credit),
        };
      });
    },
  },
  watch: {
    rowData() {
      this.onDataRendered();
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
    },
    onDataRendered() {
      const pinnedBottomData = {
        acc_code: "Total",
        debit: toShowAccountingPrice(this.jvTotal.debit),
        credit: toShowAccountingPrice(this.jvTotal.credit),
      };
      this.gridApi.setPinnedBottomRowData([pinnedBottomData]);

      this.gridColumnApi.autoSizeAllColumns();
      this.gridApi.sizeColumnsToFit();
    },
  },
  //   beforeMount() {
  //     window.addEventListener("resize", this.onFirstDataRendered);
  //   },
  //   beforeDestroy() {
  //     window.removeEventListener("resize", this.onFirstDataRendered);
  //   },
};
</script>

<style lang="scss" scoped>
.table-style {
  height: 400px;
  width: 100%;
}

* ::v-deep .ag-header-cell-label {
  justify-content: center;
}
* ::v-deep .ag-header-row-column {
  background: transparent linear-gradient(180deg, #007afe 0%, #013f81 100%);
  color: white;
}

* ::v-deep .ag-row-pinned {
  background: #ededed;
  font-size: 16px;
}

* ::v-deep .ag-apple-scrollbar {
  &.ag-scrollbar-scrolling {
    display: none !important;
  }
}
</style>
